import React from 'react';
import { CaptureOverlay } from '../shared';

interface GuidedPreflightProps {
  taskName: string;
  onNext: () => void;
  onSkipToUpload: () => void;
  onClose: () => void;
}

const STEPS = [
  { num: 1, title: 'Enable Screen Recording', desc: 'Go to Settings → Control Center → add Screen Recording' },
  { num: 2, title: 'Turn on Microphone', desc: 'Long-press the record button and enable microphone before starting' },
  { num: 3, title: 'Start Recording', desc: 'We\'ll launch the target app. Tap the Control Center record button to begin' },
  { num: 4, title: 'Return & Upload', desc: 'When done, come back to Dekko and upload the recording from your Photos' },
];

export const GuidedPreflight: React.FC<GuidedPreflightProps> = ({
  taskName,
  onNext,
  onSkipToUpload,
  onClose,
}) => {
  return (
    <CaptureOverlay taskName={taskName} onClose={onClose}>
      <div className="gc-scroll-body">
        <div className="gc-section-heading">How it works</div>

        {STEPS.map(s => (
          <div key={s.num} className="gc-step-card">
            <div className="gc-step-num">{s.num}</div>
            <div>
              <div className="gc-step-title">{s.title}</div>
              <div className="gc-step-desc">{s.desc}</div>
            </div>
          </div>
        ))}

        <div className="gc-tip-box">
          <span className="gc-tip-highlight">iOS tip:</span> The recording saves automatically to Photos when you stop via the red status bar indicator.
        </div>
      </div>

      <div className="gc-bottom-actions">
        <button className="gc-btn-cta" onClick={onNext}>
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
            <circle cx="9" cy="7" r="4" />
          </svg>
          Next: Setup Camera
        </button>
        <button className="gc-btn-skip" onClick={onSkipToUpload}>
          I already have a recording — skip to upload
        </button>
      </div>
    </CaptureOverlay>
  );
};
